import Input from 'components/atoms/Input';
import React, { useEffect, useState } from 'react';
import { TrashIcon } from '@heroicons/react/outline';
import { ISection2Type } from 'types/VehicleIncidents';
import Button from 'components/atoms/Button';
import Heading from "../../atoms/Heading";

export interface IWitnessCard {
	handleSection2Update: (
		property: ISection2Type,
		sectionLabel: string,
		index?: number,
		disableUpdateRequest?: boolean,
	) => void;
	deleteWitness(id: number): void;
	id: number;
	witness: IWitness;
	index: number;
	isDisabled: boolean;
	onBlur?: () => void;
}

export interface IWitness {
	id: number;
	witness_name: string;
	witness_position: string;
	witness_task: string;
	witness_phone_number: string;
}

const WitnessCard: React.FC<IWitnessCard> = ({
	handleSection2Update,
	deleteWitness,
	witness,
	id,
	index,
	isDisabled = false,
	onBlur,
}) => {
	const [payload, setPayload] = useState(witness);

	useEffect(() => {
		setPayload(witness);
	}, [witness]);

	const handleOnChange = (property: ISection2Type, value: string, disableUpdateRequest?: boolean) => {
		handleSection2Update(property, value, index, disableUpdateRequest);
	};

	return (
		<div className="py-[24px] px-[40px] border-solid border-[1px] bg-[#FEEDD6] mb-4 rounded-md">
			<div className="flex flex-row justify-between">
				<div className="flex flex-col justify-center">
					<Heading type="h2">Details: Witness {index + 1}</Heading>
				</div>
				<div className="flex flex-col justify-center mt-6">
					<Button
						type="quinary"
						className="font-bold !rounded-3xl px-[24px] py-[10px] tracking-[1.92px] uppercase"
						onClick={() => deleteWitness(id)}
						size="md"
					>
						<TrashIcon height={20} width={18} className="cursor-pointer"/>
						&nbsp;Delete
					</Button>
				</div>
			</div>
			<div className="flex gap-x-8 w-full flex-wrap my-3">
				<Input
					type="text"
					onChange={(value: string) => handleOnChange('witness_name', value, true)}
					value={payload.witness_name}
					onBlur={onBlur}
					className="basis-1/5 grow"
					label="Name"
					required={true}
					isDisabled={isDisabled}
				/>
				<Input
					type="tel"
					onChange={(value: string) =>
						handleOnChange('witness_phone_number', value, true)
					}
					onBlur={onBlur}
					value={payload.witness_phone_number}
					className="basis-1/5 grow"
					label="Phone Number"
					required={true}
					isDisabled={isDisabled}
				/>
				<Input
					type="text"
					onChange={(value: string) => handleOnChange('witness_position', value, true)}
					value={payload.witness_position}
					onBlur={onBlur}
					className="basis-1/5 grow"
					label="Position"
					isDisabled={isDisabled}
				/>
				<Input
					type="text"
					onChange={(value: string) => handleOnChange('witness_task', value, true)}
					value={payload.witness_task}
					onBlur={onBlur}
					className="basis-1/5 grow"
					label="Task"
					isDisabled={isDisabled}
				/>
			</div>
		</div>
	);
};

export default WitnessCard;
